<template>
	<v-app>
		<transition name="slide">
			<router-view></router-view>
		</transition>
	</v-app>
</template>

<style>
/* extend-page extends height of NoticeDatePage and CommencePage components */
.extend-page {
	min-height: 400px;
	background-color: #fafafa;
}
@media all and (max-width: 480px) {
	.v-dialog__content {
		align-items: flex-start;
	}
}
</style>

<script>
export default {
	name: 'App',
};
</script>
